import { getApplicationForPartnerProgramRequest } from '@services'
import useMonetization from '@composables/useMonetization.js'
import { msToSecs } from '@helpers/utils.js'
import authStore from '@stores/authStore.js'
import {
  isMonetizationPartnerProgramPreviewEnabled,
  isMonetizationEnabled,
} from '@helpers/bitHelper.js'
import {
  PARTNER_PROGRAM_APPLICATION_SUCCESS,
  AUTH_SCOPE_ACCOUNT,
} from '@config/monetization.js'
import partnerProgramStore, {
  gameIDsRefreshed,
} from '@shared/js/stores/partnerProgramStore.js'

export function humanPriceFormat(dollars, minDigits = 2, maxDigits = 2) {
  const amount = isNaN(dollars) ? 0 : dollars

  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  })
}

export function convertToWhole(val, round = true) {
  return round ? Math.round(val * 100) : val * 100
}

export function convertToDecimal(val, maxDigits = 2) {
  return parseFloat((val / 100).toFixed(maxDigits))
}

export async function checkMonTokenTs() {
  const { authenticate } = useMonetization()

  const scope = AUTH_SCOPE_ACCOUNT
  const current = msToSecs(Date.now())

  const { monAccessToken } = authStore()

  if (
    monAccessToken.value?.[scope] &&
    current < monAccessToken.value[scope].monetization_expiry
  ) {
    // token within expiry date
    return
  }

  // token expired
  await authenticate()
}

export async function checkPartnerProgramStatus(game) {
  if (!game) return

  const { isInPartnerProgram, addPartnerProgram, removePartnerProgram } =
    partnerProgramStore()

  if (
    authStore().isLoggedIn.value &&
    isMonetizationEnabled(game.monetization_options) &&
    isMonetizationPartnerProgramPreviewEnabled(game.monetization_options) &&
    !isInPartnerProgram(game.id).value &&
    !gameIDsRefreshed.value[game.id]
  ) {
    gameIDsRefreshed.value[game.id] = true

    try {
      const data = await getApplicationForPartnerProgramRequest(game.name_id)

      if (data?.partner_status === PARTNER_PROGRAM_APPLICATION_SUCCESS)
        addPartnerProgram(game.id)

      return
    } catch (error) {
      if (error.status !== 404)
        console.warn('Partner Program application fetch failed unexpectedly:', {
          status: error.status,
          message: error.message,
        })
    }

    removePartnerProgram(game.id)
  }
}
